export default [

     {
          path: '/center-policy',
          name: 'CenterPolicy',
          component: () => import("@/views/Page/CenterPolicy/CenterPolicy.vue"),
           meta: {
               title: 'GRC | CenterPolicy',
          },
     }
];